import { EnumSiNoTodos, FilterSearchingBaseViewModel, PagingResultsViewModel } from '../../../core/_infrastructure/types/common';
import { CultivoViewModel } from '../../cultivos/cultivo.types';
export class RecintoUnidadInspeccionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: RecintoUnidadInspeccionItemViewModel[];
}
export class FilterSearchingRecintoUnidadInspeccion extends FilterSearchingBaseViewModel {
    public Autorizado?: number = EnumSiNoTodos.TODOS;
    public Activa?: boolean | number;
    public IdCampania?: number;
    public IdPeriodo?: number;
    public IdCA?: number;
    public IdEntidadAuditora?: number;
    public CodigoUhc: string;
    public IdTipoSolicitudCam?: number;
    public IdEstadoUnidadInspeccion?: number;
    public IdProvincia?: number;
    public IdMunicipio?: number;
    public Agregado?: number;
    public Zona?: number;
    public Poligono?: number;
    public Parcela?: number;
    public Recinto?: number;
    public IdOperador?: number;
    public NumeroRegistro?: string; // Dato del almacén
    public RegistroSanitario?: string; // Dato del almacén
    public FechaDesdePresentacion?: Date; // Campo usado solamente en el búscador de recintos disponibles para la UI
    public FechaHastaPresentacion?: Date; // Campo usado solamente en el búscador de recintos disponibles para la UI
    public IdUsuario?: number; // Este campo no se rellena en el front. Se indica por compatibilidad de tipos con el core.
}
export class RecintoUnidadInspeccionItemViewModelBase {
    public Id: number; // Id del Recinto-UI
    public FechaCreacion: Date;
    public IdUi?: number;
    public IdEstadoUi?: number;
    public EstadoUi: string;
    public CodigoUhc: string;
    public IdUsuarioBaja?: number;
    public FechaBaja?: Date;
    public IdCampania: number;
    public Campania: string;
    public IdPeriodo: number;
    public Periodo: string;
    public PeriodoEnPlazoVigente: boolean;
    public IdTipoSolicitudCam: number;
    public TipoSolicitud: string;
    public IdCa: number;
    public IdEntidadAuditora: number;
    public EntidadAuditora: string;
    public DescripcionComunidad: string;
}

export class RecintoUnidadInspeccionItemViewModel extends RecintoUnidadInspeccionItemViewModelBase {
    EmpresaDeshidratadora: EmpDeshidratadoraViewModelExtended;
    Almacen: AlmacenViewModelExtended;
    Cultivo: CultivoViewModelExtended;
}

export class CultivoViewModelExtended extends CultivoViewModel {
    public Recinto: RecintoViewModel;
    public SolicitudCam: RecintoUiSolicitudCamItemViewModel;
}

export class EmpDeshidratadoraViewModelExtended {
    // Campos relativos a la empresa deshidratadora
    Id?: number;
    NumeroRegistro: string;
    NombreIndustria: string;
    IdProvincia: number;
    IdMunicipio: number;
    Provincia: number;
    Municipio: number;
    Desautorizada?: boolean;
    SolicitudCam: RecintoUiSolicitudCamItemViewModel;
}

export class AlmacenViewModelExtended {
    // Datos del Almacén
    Id?: number;
    RegistroSanitario: string;
    RazonSocial: string;
    IdProvincia: number;
    IdMunicipio: number;
    Provincia: number;
    Municipio: number;
    Desautorizado: boolean;
    SolicitudCam: RecintoUiSolicitudCamItemViewModel;
}

export class RecintoUiSolicitudCamItemViewModel {
    // Datos de la solicitud
    FechaPresentacion: Date;
    IdSolicitudCam: number;
    IdUsuario?: number;
    IdOperador?: number;
    OperadorRazonSocial: string;
    CodigoSolicitud: string;
    TipoRecinto: string;
}

export class RecintoViewModel {
    Id: number;
    Titular: string;
    Nif: string;
    SuperficieTotal?: number;
    CodigoSigPac: string;
    IdProvincia: number;
    Provincia: string;
    IdMunicipio: number;
    Municipio: string;

    // SIGPAC
    IdMunicipioSigPac: number;
    Agregado: string;
    Zona: string;
    Poligono: string;
    Parcela: string;
    Recinto: string;
}
